'use strict'
const getLogs = (odds) => {
  if (_.isEmpty(_.get(odds, 'logs')) || _.get(odds, 'winning') !== null) {
    return ''
  }

  let data = ''

  const oddsReverse = _.reverse(_.cloneDeep(odds.logs))
  for (let odd in oddsReverse) {
    let suspendClass = (oddsReverse[odd].suspend_changed ? 'c-suspend' : '')
    const classUnactive = (odd==0?'':'c-unactive')
    data += `<tr class="${suspendClass} ${classUnactive}">
                          <td><strong class="c-rate-odds1">${oddsReverse[odd].value_changed}</strong></td>
                          <td> ${(oddsReverse[odd].suspend_changed ? 'ยกเลิก' : '-')}</td>
                          <td>${oddsReverse[odd].created_at}</td>
                          <tr class="${suspendClass}"></tr>`
  }

  let html = `
                          <table class="table m-b-none"><thead><tr><td>อัตราจ่าย</td><td>สถานะ</td><td>เปลี่ยนเมื่อ</td></tr></thead>
                          <tbody>${data}</tbody>
                          </table>`
  const classChange = (_.first(oddsReverse).value_changed > odds.value ? 'down' : '')
  return `<span class="log-popup ${classChange}">${html}</span>`
}
const setSortHDA = (odds) => {
  let data = []
  for (let o in odds) {
    if (odds[o].header === 'Home' || odds[o].header === '1') {
      data.push(odds[o])
    }
  }
  for (let o in odds) {
    if (odds[o].header === 'Draw' || odds[o].header === 'X') {
      data.push(odds[o])
    }
  }
  for (let o in odds) {
    if (odds[o].header === 'Away' || odds[o].header === '2') {
      data.push(odds[o])
    }
  }

  for (let o in odds) {
    const headers = ['Home','1','2','Draw','X','Away']
    if (_.includes(headers,odds[o].header)) {
    }else{
      data.push(odds[o])
    }
  }
  return data
}
const getMatchStatus = (fixture) => {
  let html = fixture.ref_status
  if (fixture.ref_status === 'LIVE') {
    html += `<br/><span class="inplay_score"><i class="fa fa-circle text-primary fa-blink "></i></span>`
    if(fixture.time_minute!== null && fixture.time_minute !==''){
      html += ` <span class="text-danger">${fixture.time_minute}'</span>`
    }else{
      html += ` <span class="text-danger">0'</span>`
    }
  } else if (fixture.ref_status === 'HT') {
    html += `<br/><span class="inplay_score"><i class="fa fa-circle text-primary fa-blink"></i></span> <span class="text-danger">45'</span>`
  }
  return html
}

const getTeamIcon = (logoPath) => {
  let data = ''
  if(logoPath) {
    data +=`<img src="https://assets.b365api.com/images/team/s/${logoPath}.png" onerror="this.remove()"/>`
  }
  return data
}
const paymentClass = (record) => {
  let classPayment = ''
  if (record.payment_rate == 0.5) {
    classPayment = 'label-danger'
  } else if (record.payment_rate == 1) {
    classPayment = 'label-warning'
  } else if (record.payment_rate == 1.5) {
    classPayment = 'label-info'
  } else if (record.payment_rate == 2) {
    classPayment = 'label-primary'
  }
  return classPayment
}

const scoreDisplay = (fixture)=>{
  if(_.includes(['LIVE', 'HT', 'FT', 'ET', 'PEN_LIVE', 'AET', 'BREAK', 'FT_PEN', 'TBF'], fixture.ref_status)){
    return true
  }
  return false
}
const scoreDisplayScore = (fixture)=>{
  let reg = new RegExp('^[0-9]$')
  let score ='?-?'
  if(reg.test(fixture.localteam_score) && reg.test(fixture.visitorteam_score)){
    score = `${fixture.localteam_score}-${fixture.visitorteam_score}`
  }
  return score
}
const getMoment = (value,format='HH:mm',local='th')=>{
  moment.locale(local)
  return moment(value).format(format)
}
export {getMoment, scoreDisplayScore, scoreDisplay, paymentClass, getLogs, setSortHDA, getMatchStatus, getTeamIcon}




// WEBPACK FOOTER //
// ./resources/assets/js/admin/pages/sports/helpers.js